import { render } from "./DetailsUpdateSales.vue?vue&type=template&id=4ebe78b4"
import script from "./DetailsUpdateSales.vue?vue&type=script&lang=js"
export * from "./DetailsUpdateSales.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__